module.exports = __webpack_public_path__ + "img/dun.0979b889.png";